// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    applicationId: z.string().min(1).max(21),
    userId: z.string().min(1).max(128),
});
const guard = z.object({
    tenantId: z.string().max(21),
    applicationId: z.string().min(1).max(21),
    userId: z.string().min(1).max(128),
});
export const ApplicationAccessControlUserRelations = Object.freeze({
    table: 'application_access_control_user_relations',
    tableSingular: 'application_access_control_user_relation',
    fields: {
        tenantId: 'tenant_id',
        applicationId: 'application_id',
        userId: 'user_id',
    },
    fieldKeys: [
        'tenantId',
        'applicationId',
        'userId',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
